<nav class="tabbar" [ngClass]="{ 'ios-standalone': isIOSStandalone(), 'android-standlaone': isAndroidStandalone() }">
	<a routerLink="/" [class.active]="isDashboardActive()" (click)="onTabClick('/', $event)">
		<sp-image class="linkImage" imageFilename="dashboard"></sp-image>
		<span class="linkLabel">Dashboard</span>
	</a>
	<a routerLink="/itinerary" routerLinkActive="active" (click)="onTabClick('/itinerary', $event)">
		<sp-image class="linkImage" imageFilename="itinerary"></sp-image>
		<span class="linkLabel">Itinerary</span>
	</a>
	<a routerLink="/journal" routerLinkActive="active" (click)="onTabClick('/journal', $event)">
		<sp-image class="linkImage" imageFilename="journal"></sp-image>
		<span class="linkLabel">Journal</span>
	</a>
	<a routerLink="/favorites" routerLinkActive="active" (click)="onTabClick('/favorites', $event)">
		<sp-image class="linkImage" imageFilename="bookmark"></sp-image>
		<span class="linkLabel">Favorites</span>
	</a>
</nav>
